const AlertSuccess = (props: React.HTMLAttributes<SVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <rect width="24" height="24" rx="12" fill="#21AA3E" />
    <path d="M5 11.5L9.5 16.9998L19 7" stroke="white" strokeWidth="2" />
  </svg>
);
export default AlertSuccess;
